import BUSD_ABI from "../Contracts/BUSD_ABI.json";
import contractABI from "../Contracts/contract_ABI.json";
import tokenABI from "../Contracts/Token_ABI.json";
import ATMTokenABI from "../Contracts/ATMTokenABI.json";

////////////////mainnet//////////////////
// const arr = {
//   contract: "0x39b022Cd9d8297A16465daF3BcAE603572a2529b",
//   contractABI: contractABI,
//   BUSD: "0x55d398326f99059fF775485246999027B3197955",
//   BUSD_ABI: BUSD_ABI,
//   ATMToken:"0x55d398326f99059fF775485246999027B3197955",
//   ATMTokenABI:ATMTokenABI,
// };

// Testnet
const arr = {
  contract: "0xad8d380617C010B7eCe8B7A7b32BF147E1525F18",
  contractABI: contractABI,
  BUSD: "0xa97f6c3e422a00a7a5B363340DF431b7d5412483",
  BUSD_ABI: BUSD_ABI,
  ATMToken:"0x771d76a2F35b8809119cc712cD9010A19164DFad",
  ATMTokenABI:ATMTokenABI,
};

// Testnet
// const arr = {
//   contract: "0xCE74ecA7E8f5563dC10263311bCCb756b6F3F548",
//   contractABI: contractABI,
//   BUSD: "0x55d398326f99059fF775485246999027B3197955",
//   BUSD_ABI: BUSD_ABI,
//   ATMToken:"0x55d398326f99059fF775485246999027B3197955",
//   ATMTokenABI:ATMTokenABI,
// };


////////////////testnet//////////////////
// const arr = {
//   contract: "0x86b7a3f5179B264122F402f72E5375ca8ce6740C",
//   contractABI: contractABI,
//   BUSD: "0x771d76a2F35b8809119cc712cD9010A19164DFad",
//   BUSD_ABI: BUSD_ABI,//currently using this

//   token: "0x771d76a2F35b8809119cc712cD9010A19164DFad ",
//   tokenABI: tokenABI,
//   ATMToken:"0x771d76a2F35b8809119cc712cD9010A19164DFad",
//   ATMTokenABI:ATMTokenABI,
// };

export const ContractDetails = arr;

// Action creators are generated for each case reducer function

export default ContractDetails;
